import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLoadContacts } from "../../hooks/useLoadContacts";
import { useShareContent } from "../../hooks/useShareContent";
import { SubmitButton } from "../shared/buttons/submit-button";
import { Modal } from "../shared/modal";
import ThemedSelect from "../shared/themed-select";

interface ShareContentModalProps {
  contentId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const ShareContentModal = ({
  contentId,
  isOpen,
  onClose,
}: ShareContentModalProps) => {
  const { contacts } = useLoadContacts();
  const { share, isPending } = useShareContent();
  const [contactId, setContactId] = useState("");
  const [warningMessage, setWarningMessage] = useState("");

  const handleShare = async () => {
    if (!contactId) return;

    const foundContact = contacts.find((c) => c.id === contactId);

    if (!foundContact) {
      setWarningMessage("Contact not found");
      return;
    }
    if (!foundContact.related_user.email && !foundContact.related_user.phone) {
      setWarningMessage(
        "Contact has no email or phone. Please add an email address or phone number to send content to this person."
      );
      return;
    }

    share({ contentId, contactId });
    onClose();
  };

  useEffect(() => {
    if (warningMessage) {
      setTimeout(() => {
        setWarningMessage("");
      }, 5000);
    }
  }, [warningMessage]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Share Content">
      <div className="flex flex-col gap-4 w-64">
        <ThemedSelect
          placeholder="Select contact"
          options={contacts.map((c) => ({
            value: c.id,
            label: `${c.related_user.first_name} ${c.related_user.last_name}`,
          }))}
          value={contactId}
          onChange={(e) => setContactId(e.target.value)}
        />
        {/* Warning message */}
        {warningMessage && (
          <div className="flex flex-col gap-2">
            <div className="text-sm text-terracotta-500">{warningMessage}</div>
            <Link to={`/contacts/update/${contactId}`}>
              <div className="text-md underline">Update contact</div>
            </Link>
          </div>
        )}
        <SubmitButton
          onClick={handleShare}
          isDisabled={!contactId}
          isLoading={isPending}
        >
          Share
        </SubmitButton>
      </div>
    </Modal>
  );
};
